import { CURATED_REVIEWS, averageCuratedRating } from './curatedReviews';

function StarDisplay({
  rating,
  size = 'md',
}: {
  rating: number;
  size?: 'md' | 'lg';
}) {
  return (
    <div
      className={`azalea-stars azalea-stars--${size}`}
      aria-label={`${rating} out of 5 stars`}
    >
      {[1, 2, 3, 4, 5].map((star) => (
        <span key={star} className={star <= rating ? 'azalea-star filled' : 'azalea-star'}>
          ★
        </span>
      ))}
    </div>
  );
}

export function AzaleaReviews() {
  const reviews = CURATED_REVIEWS;
  const avg = averageCuratedRating(reviews);

  return (
    <section
      className="azalea-section azalea-section-narrow azalea-reviews"
      aria-labelledby="azalea-reviews-title"
    >
      <h2 id="azalea-reviews-title">Reviews</h2>
      <p className="azalea-reviews-intro">
        What families, caregivers, and educators are saying about Azalea.
      </p>

      <div className="azalea-reviews-summary">
        <StarDisplay rating={Math.round(avg)} size="lg" />
        <p>
          <strong>{avg}</strong> out of 5 · {reviews.length} reviews
        </p>
      </div>

      <ul className="azalea-review-list">
        {reviews.map((review) => (
          <li key={review.id} className="azalea-review-item">
            <div className="azalea-review-item-head">
              <div>
                <strong>{review.name}</strong>
                <p className="azalea-review-role">{review.role}</p>
              </div>
              <StarDisplay rating={review.rating} />
            </div>
            <p className="azalea-review-title">{review.title}</p>
            <p className="azalea-review-body">{review.comment}</p>
            <p className="azalea-review-date">{review.date}</p>
          </li>
        ))}
      </ul>
    </section>
  );
}
